import React from 'react'
import PropTypes from 'prop-types'

import StarredItem from "../../../model2/starred/starred-item"
import HintPopover from "../../../gd-ui/hint-popover/hint-popover"

export default class Starred extends React.Component<any> {
    static propTypes = {
        renderType: PropTypes.oneOf(['default', 'ui5']),
        params: PropTypes.object.isRequired, //{taskId,projectId,companyId}
        hint: PropTypes.bool
    };

    static defaultProps = {
        renderType: 'default',
        hint: true
    };

    UNSAFE_componentWillReceiveProps(nextProps:any) {
        this.setState({
            isStarred: this.checkIsInStarred(nextProps.params)
        });
    }

    checkIsInStarred = (params:any) => {
        let out = false;
        if (params.taskId)      out = !!gd.session.starredItems.getTaskStarredItem(params.taskId)
        if (params.projectId)   out = !!gd.session.starredItems.getProjectStarredItem(params.projectId)
        return out;
    };

    onClick = () => {
        if (this.state.isStarred) {
            // Delete favorite
            const item = this.props.params.taskId ?
                gd.session.starredItems.getTaskStarredItem(this.props.params.taskId)
                :
                gd.session.starredItems.getProjectStarredItem(this.props.params.projectId)

            const request = gd.api.Starred.removeFromStarred(this.props.params.taskId,this.props.params.projectId)

            this.setState({isStarred:false});

            request.done((data:any)=>{gd.session.starredItems.removeItem(item)})
            request.fail((error:any)=>{this.setState({isStarred:true});});
        } else {

            const request = gd.api.Starred.addToStarred(this.props.params.taskId,this.props.params.projectId);

            this.setState({isStarred:true});

            request.done((data:any)=>{
                const modelData:any = {companyId: gd.companyId};
                if (this.props.params.taskId) modelData.taskId = this.props.params.taskId;
                else if (this.props.params.projectId) modelData.projectId = this.props.params.projectId;

                gd.session.starredItems.add(new StarredItem(modelData))
            });

            request.fail((error:any)=>{this.setState({isStarred:false}); gd.apiError(error)});
        }
    };

    state = {
        isStarred: this.checkIsInStarred(this.props.params)
    };

    render() {
        let classes;
        switch (this.props.renderType) {
            case 'ui5':
                classes = Classes("ui5-ico-14", this.props.className, {
                    'i5-star-empty': !this.state.isStarred,
                    'i5-star': this.state.isStarred
                });
                break;

            default:
                classes = Classes('ui5-ico-starred', this.props.className, {
                    'not-selected': !this.state.isStarred,
                    'selected': this.state.isStarred,
                });
                break;
        }

        let hint:any = false;
        if (this.props.hint) {
            const hintMessage = this.state.isStarred ? "Unstar" : "Mark as important";
            hint = <HintPopover hint={hintMessage}/>
        }

        return <div className={classes} onClick={this.onClick}>{hint}</div>;
    }
}